import { useQuery } from "@tanstack/react-query";

import { getSettings } from "services";

import { GET_ADMIN_SETTINGS } from "consts";

export const useGetAdminSettings = () =>
  useQuery({
    queryKey: [GET_ADMIN_SETTINGS],
    queryFn: getSettings,
    staleTime: 1000 * 60 * 60, // 1 hour
  });
